module.exports = __webpack_public_path__ + "static/media/GameIcon.d622dd8c.png";